import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import CountryLabel from '../../../components/CountryLabel/CountryLabel';
import Switch from '../../../components/Switch/Switch';
import { formatNumber } from '../../../core/helpers';
import { ClientWarehouse } from '../../../core/types';

interface Props {
  warehouse: ClientWarehouse;
  className?: string;
  vatIds: string[];
  onClickVATIdSwitch: (c: string) => () => void;
}

export default function SetupCheckWarehousesItem({
  warehouse,
  className = '',
  vatIds,
  onClickVATIdSwitch,
}: Props) {
  const { t } = useTranslation();
  const isActiveWholeYear =
    warehouse.active_from.getDate() === 1 &&
    warehouse.active_from.getMonth() === 0 &&
    warehouse.active_from.getFullYear() === 2021;
  return (
    <div className={`border-top ${className} pt-2`}>
      <CountryLabel country={warehouse.country} className='mb-2' />
      <div className='row mb-2'>
        <div className='col'>{t('Since')}</div>
        <div className='col text-end'>
          {isActiveWholeYear
            ? t('Whole year')
            : format(warehouse.active_from, 'dd.MM.yyyy')}
        </div>
      </div>
      <div className='row mb-2'>
        <div className='col'>{t('Items sold')}</div>
        <div className='col text-end'>
          {formatNumber(warehouse.count_of_sold_items)}
        </div>
      </div>
      <div className='row align-items-center'>
        <div className='col'>{t('Registered VAT ID')}</div>
        <div className='col d-flex justify-content-end'>
          <Switch
            checked={vatIds.includes(warehouse.country)}
            onChange={onClickVATIdSwitch(warehouse.country)}
          />
        </div>
      </div>
    </div>
  );
}
